import type { enStokRequests } from '../en/stok-requests';

export const idStokRequests: Record<keyof typeof enStokRequests, string> = {
  // ---- Status labels
  'stok.pr.status.draft': 'Draf',
  'stok.pr.status.pending_approval': 'Menunggu persetujuan',
  'stok.pr.status.approved': 'Disetujui',
  'stok.pr.status.rejected': 'Ditolak',
  'stok.pr.status.cancelled': 'Dibatalkan',
  'stok.pr.status.converted': 'Jadi PO',

  // ---- List
  'stok.pr.title': 'Permintaan pembelian',
  'stok.pr.subtitle': 'Kebutuhan belanja dapur dan gudang, terbaru di atas.',
  'stok.pr.create': 'Buat permintaan',
  'stok.pr.readOnly': 'Hanya baca — membuat permintaan memerlukan izin permintaan pembelian.',
  'stok.pr.noPermission': 'Anda tidak memiliki akses ke permintaan pembelian di cabang ini.',
  'stok.pr.noRequest': 'Minta pengguna dengan izin permintaan pembelian untuk membuat permintaan.',
  'stok.pr.listTitle': 'Permintaan',
  'stok.pr.listDesc': 'Buka permintaan untuk melihat baris, langkah persetujuan, dan PO-nya.',
  'stok.pr.statusFilter': 'Saring menurut status',
  'stok.pr.searchPlaceholder': 'Nomor permintaan, pemohon, atau anggaran',
  'stok.pr.empty': 'Belum ada permintaan pembelian — buat untuk barang yang perlu dibeli.',
  'stok.pr.emptyReadOnly': 'Belum ada permintaan pembelian — muncul setelah seseorang membuatnya.',
  'stok.pr.emptyFiltered': 'Tidak ada permintaan dengan status ini.',
  'stok.pr.number': 'No. permintaan',
  'stok.pr.requestedBy': 'Diminta oleh',
  'stok.pr.requestedByName': 'Diminta oleh {name}',
  'stok.pr.allRequesters': 'Semua pemohon',
  'stok.pr.neededBy': 'Dibutuhkan tanggal',
  'stok.pr.total': 'Total perkiraan',

  // ---- Budget line
  'stok.pr.budget.column': 'Pos anggaran',
  'stok.pr.budget.label': 'Pos anggaran',
  'stok.pr.budget.hint': 'Pos yang disetujui untuk {period}; jumlahnya dicadangkan saat disetujui.',
  'stok.pr.budget.none': 'Tanpa anggaran',
  'stok.pr.budget.option': '{label} — sisa {available}',
  'stok.pr.budget.saved': 'Pos anggaran tersimpan',
  'stok.pr.budget.loading': 'Memuat pos anggaran…',
  'stok.pr.budget.loadFailed':
    'Pos anggaran tidak dapat dimuat — simpan tanpa anggaran atau coba lagi.',
  'stok.pr.budget.empty': 'Belum ada pos anggaran yang disetujui untuk {period}.',
  'stok.pr.budget.otherPeriod': 'Pos tersimpan bukan pos anggaran bulan ini yang disetujui.',
  'stok.pr.budget.available': 'Sisa',
  'stok.pr.budget.over': 'Total {total} melebihi sisa anggaran {available}.',
  'stok.pr.budget.overBlock': 'Pengajuan akan ditolak oleh pos anggaran ini.',
  'stok.pr.budget.overEscalate': 'Pengajuan memerlukan persetujuan tambahan (eskalasi).',

  // ---- Form
  'stok.pr.backToList': 'Semua permintaan pembelian',
  'stok.pr.newTitle': 'Permintaan pembelian baru',
  'stok.pr.newSubtitle': 'Disimpan sebagai draf; ajukan persetujuan setelah lengkap.',
  'stok.pr.detailTitle': 'Permintaan pembelian',
  'stok.pr.editTitle': 'Ubah draf {number}',
  'stok.pr.editSubtitle': 'Menyimpan akan mengganti semua baris draf.',
  'stok.pr.headTitle': 'Rincian permintaan',
  'stok.pr.headDesc': 'Pos anggaran, kapan barang dibutuhkan, dan alasannya.',
  'stok.pr.notesHint': 'Alasan kebutuhan, mis. acara akhir pekan atau stok menipis.',
  'stok.pr.linesFormDesc':
    'Jumlah dalam satuan yang dipilih, perkiraan harga per satu satuan sebelum pajak. Maksimal {max} baris.',
  'stok.pr.estPriceLabel': 'Perkiraan harga per {unit} ({currency})',
  'stok.pr.suggestedSupplier': 'Saran pemasok',
  'stok.pr.noSupplier': 'Tanpa saran',
  'stok.pr.suppliersHidden':
    'Daftar pemasok tidak dapat dimuat, jadi saran pemasok tidak tersedia. Permintaan tetap bisa disimpan — bagian pembelian yang memilih pemasok.',
  'stok.pr.draftNote': 'Draf masih bisa diubah sampai diajukan.',
  'stok.pr.created': 'Permintaan pembelian {number} disimpan sebagai draf.',
  'stok.pr.saved': 'Permintaan pembelian {number} disimpan.',
  'stok.pr.err.tooManyLines': 'Satu permintaan maksimal 100 baris.',

  // ---- Detail
  'stok.pr.factsTitle': 'Permintaan',
  'stok.pr.factsDesc': 'Siapa yang meminta, kapan dibutuhkan, dan anggaran yang dipakai.',
  'stok.pr.linesDesc': 'Jumlah dalam satuan tiap baris; harga adalah perkiraan.',
  'stok.pr.estPrice': 'Perkiraan harga',
  'stok.pr.supplierHidden': 'Ada saran',
  'stok.pr.purchaseOrder': 'Pesanan pembelian',
  'stok.pr.openPo': 'Buka pesanan pembelian',
  'stok.pr.cancelReason': 'Alasan pembatalan',
  'stok.pr.note.draft': 'Draf — ajukan persetujuan setelah lengkap.',
  'stok.pr.note.draftReadOnly': 'Draf — pemohon yang mengajukan persetujuan.',
  'stok.pr.note.pending': 'Menunggu persetujuan — lihat langkah persetujuan di bawah.',
  'stok.pr.note.approved': 'Disetujui — bagian pembelian akan membuat pesanan pembelian.',
  'stok.pr.note.approvedManage':
    'Disetujui — buat pesanan pembelian dengan pemasok dan harga hasil negosiasi.',
  'stok.pr.note.rejected':
    'Ditolak — lihat alasan penyetuju di bawah; buat permintaan baru bila masih diperlukan.',
  'stok.pr.budgetExceededHelp':
    'Pilih pos anggaran lain atau kurangi jumlah atau harga, lalu ajukan lagi.',
  'stok.pr.editDraft': 'Ubah draf',

  // ---- Submit / cancel
  'stok.pr.submit': 'Ajukan persetujuan',
  'stok.pr.submitting': 'Mengajukan…',
  'stok.pr.submitTitle': 'Ajukan permintaan {number}?',
  'stok.pr.submitBody': 'Permintaan tidak bisa diubah selama menunggu persetujuan.',
  'stok.pr.submitBudget':
    'Pos anggaran diperiksa sekarang; jumlahnya dicadangkan saat permintaan disetujui.',
  'stok.pr.submitNoBudget': 'Tidak ada pos anggaran — tanpa kontrol anggaran.',
  'stok.pr.submitted': 'Permintaan pembelian {number} diajukan.',
  'stok.pr.cancel': 'Batalkan permintaan',
  'stok.pr.cancelling': 'Membatalkan…',
  'stok.pr.cancelTitle': 'Batalkan permintaan {number}?',
  'stok.pr.cancelBody': 'Draf ditutup dan tidak dapat diajukan lagi.',
  'stok.pr.cancelBodyPending': 'Persetujuan yang sedang berjalan ditarik.',
  'stok.pr.cancelBodyApproved': 'Jumlah yang dicadangkan pada pos anggaran dilepas.',
  'stok.pr.cancelled': 'Permintaan pembelian {number} dibatalkan.',

  // ---- Convert to a purchase order
  'stok.pr.convert': 'Buat PO',
  'stok.pr.converting': 'Membuat…',
  'stok.pr.convertTitle': 'Buat pesanan pembelian dari {number}',
  'stok.pr.convertDesc': 'Pilih pemasok dan pastikan harga hasil negosiasi tiap baris.',
  'stok.pr.convertPrice': 'Harga {item} per {unit} ({currency})',
  'stok.pr.estimate': 'perkiraan',
  'stok.pr.poTotal': 'Total pesanan pembelian',
  'stok.pr.approvedTotal': 'Total permintaan yang disetujui',
  'stok.pr.convertWithin':
    'Dalam total yang disetujui — pesanan langsung disetujui (mewarisi persetujuan ini).',
  'stok.pr.convertAbove':
    'Di atas total yang disetujui — pesanan dibuat sebagai draf dan harus diajukan untuk persetujuan.',
  'stok.pr.convertRule':
    'Sampai total yang disetujui, pesanan mewarisi persetujuan permintaan; di atasnya, seluruh jumlah perlu persetujuan baru.',
  'stok.pr.convertedApproved': 'Pesanan pembelian {number} dibuat dan disetujui.',
  'stok.pr.convertedDraft':
    'Pesanan pembelian {number} dibuat sebagai draf — ajukan untuk persetujuan.',
};
